<template>
    <div class="home-container">
        <NavHide :currentActive="'Home'" v-if="currentSection == 0" />
        <Nav :currentActive="'Home'" v-else />

      <div class="section" :ref="(el) => sectionRefs[0] = el" id="banner">
        <div class="video-container">
            <video src="@/assets/videos/index_banner.mp4" autoplay muted loop @pause="preventPause">
                您的浏览器不支持视频播放。
            </video>
        </div>
        <div class="title_box">
            <div class="title_container">
                <div class="title_text_box">
                    <div class="text_01 fs40">链网协同构建新业态</div>
                    <div class="text_02 fs40 mt20">粤澳齐心共建新秩序</div>
                    <div class="line_01 mt20"></div>
                </div>
                
            </div>
            
        </div>
        <div class="btn-toggle" @click="scrollToSectionById('section2');"><i></i>向下滑动</div>
        
      </div>
      <div class="section" :ref="(el) => sectionRefs[0] = el" id="introduction">
        <div class="introduction">
            <div class="pic">
                <img src="@/assets/images/intro-pic-bg.png" class="intro-pic" />
                <div class="one">
                    <img src="@/assets/images/intro-pic-li1.png" />
                </div>
                <div class="two">
                    <img src="@/assets/images/intro-pic-li2.png" />
                </div>
                <div class="three">
                    <img src="@/assets/images/intro-pic-li3.png" />
                </div>
                <div class="four">
                    <img src="@/assets/images/intro-pic-li4.png" />
                </div>
            </div>
            <div class="content">
                <p></p>
                <p>融贯国际</p>
                <p></p>
                <p>链接湾区 融贯全球</p>
                <p></p>
                <p>珠海横琴融贯国际科技发展有限公司（以下简称“融贯国际”）是澳门融贯投资科技有限公司的内地投资主体，专注于发展产业数字化新基建、产业运营、产业投资、产业开发等全国性项目。公司目前聚焦于产业互联的数字经济，以“推动产业振兴，增进民生福祉”为责任，利用澳门平台优势，积极配合国家发展战略，全面加速推进星火链网在不同领域的创新应用，打造中国版Web3.0生态，协助澳门产业多元。</p>
                <p></p>
                <p>2021年9月，融贯国际取得了国家级区块链新型基础设施“星火·链网”骨干节点（珠海横琴）运营牌照；次年12月，大湾区第一个国际节点——“星火·链网”超级节点（澳门）落地澳门，由澳门融贯承接建设。“超级+骨干”双节点，将进一步筑牢湾区数字底座，为大湾区数字经济提供持续性创新驱动力，推动粤澳深度合作，促进智能制造、跨境贸易快速发展。</p>
                <a href="/About">
                    <div class="com-btn">
                        了解更多
                    </div>
                </a>
            </div>
        </div>
      </div>
      <div class="section" :ref="(el) => sectionRefs[0] = el" id="solution">
        <div class="solution">
            <div class="solution-bg">
                <div class="bg" :class="solutionAction == 0 ? 'active' : ''">
                    <img src="@/assets/images/solution_bg_01.jpg" class="full-cover" />
                </div>
                <div class="bg" :class="solutionAction == 1 ? 'active' : ''">
                    <img src="@/assets/images/solution_bg_02.jpg" class="full-cover" />
                </div>
                <div class="bg" :class="solutionAction == 2 ? 'active' : ''">
                    <img src="@/assets/images/solution_bg_03.jpg" class="full-cover" />
                </div>
                <div class="bg" :class="solutionAction == 3 ? 'active' : ''">
                    <img src="@/assets/images/solution_bg_04.jpg" class="full-cover" />
                </div>
            </div>
            <div class="solution-container">
                <div class="solution-title">平台服务</div>
                <div class="solution-text-01">全方位、全生命周期的一站式区块链解决方案</div>
                <div class="solution-content mt44">
                    <div class="solution-list">
                        <div class="solution-item" v-for="solution in solutionList" :key="solution.id"
                            :class="solutionActive == solution.id ? 'active' : ''" @click="solutionActive = solution.id">
                            <div class="solution-line"></div>
                            <div class="solution-title">{{ solution.title }}</div>
                        </div>
                    </div>
                    <div class="solution-item-content">
                        <div class="swiper-container">
                            <div class="swiper-wrapper" :style="'width:' + (solutionList.length * 100) +'%;transform: translate3d('+(100 / solutionList.length * -(solutionActive - 1))+'%, 0px, 0px);'">
                                <div class="swiper-item" v-for="solution in solutionList" :key="solution.id" :style="'width:' + (100 / solutionList.length) + '%;'"
                                    :class="solutionActive == solution.id ? 'active' : ''">
                                    <div class="title">{{ solution.title }}</div>
                                    <div class="desc">{{ solution.content }}</div>
                                    <div class="label_list">
                                        <div class="label_item" v-for="item in solution.label" :key="item">{{ item }}</div>
                                        <div class="label_item_btn" v-if="solution.link">了解更多</div>
                                    </div>
                                    <div class="logo_list">
                                        <div class="logo_item" v-for="(item,index) in solution.logo" :key="index">
                                            <img :src="item" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="section" :ref="(el) => sectionRefs[0] = el" id="cooperator">
        <div class="cooperator">
            <div class="cooperator-bg" :class="startAnimate ? 'animate' : ''">
                <div class="bg1">
                    <img src="@/assets/images/q1.png" class="full-cover" />
                </div>
                <div class="bg2">
                    <img src="@/assets/images/q4.png" class="full-cover" />
                </div>
                <div class="bg3">
                    <img src="@/assets/images/q3.png" class="full-cover" />
                </div>
                <div class="bg4">
                    <img src="@/assets/images/q2.png" class="full-cover" />
                </div>
                <div class="bg5">
                    <img src="@/assets/images/q5.png" class="full-cover" />
                </div>
                <div class="bg6">
                    <img src="@/assets/images/q6.png" class="full-cover" />
                </div>
            </div>
            <div class="cooperator-container">
                <div class="cooperator-title">战略合作</div>
                <div class="cooperator-text-01">欢迎各行业加入横琴粤澳链链网生态</div>
                <div class="cooperator-content mt44">
                    <div class="cooperator-list">
                        <div class="cooperator-item" v-for="index in 12" :key="index">
                            <img :src="require('@/assets/images/logo-'+index+'.png')" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div  class="" :ref="(el) => sectionRefs[0] = el" id="footer">
        <Footer />
      </div>
      <div class="fp-right-nav">
        <ul>
          <li v-for="(section, index) in sections" :style="(index != sections.length - 1) ? '' : 'display:none;'" :key="index" :class="{ active: currentSection === index }" @click="goToSection(index)">
            <span></span>
          </li>
        </ul>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted, watch } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import Nav from '../../components/NavTop.vue';
  import NavHide from '../../components/NavTopHide.vue';
  import Footer from '../../components/Footer.vue';
  
  const sections = ref([
  { id: 'banner', title: '功能模块 1' },
  { id: 'introduction', title: '功能模块 2' },
  { id: 'solution', title: '功能模块 3' },
  { id: 'cooperator', title: '功能模块 4' },
  { id: 'footer', title: '功能模块 5' }
  ]);

  const startAnimate = ref(false)
  const solutionList = ref([
    { 
        id: 1, 
        title: '中医药全产业链',
        content: '在中医药产业，“星火·链网”（珠海横琴）骨干节点利用区块链+标识解析技术，依托中药质量研究国家重点实验室授权认证，通过BID搭建中医药全产业链体系，涵盖中药材可追溯体系、实现监管标准化、添加中药材分级认证信息，为中草药提供可信数据网络和平台，实现来源可知、去向可踪、质量可控、责任可究，促进中医药产业化、国际化发展。' ,
        label: [
            '育种研发',
            '种植可视化',
            '产品标准制定',
            '产品等级认证',
        ],
        link: '1',
        logo: [
            require('@/assets/images/solution-logo-01-01.png')
        ]
    },
    { 
        id: 2, 
        title: '茶叶子链',
        content: '基于骨干节点技术在茶叶产业搭建茶叶子链，实现数据无缝衔接，打造茶叶产品全生命周期可信数据体系，实现种植、交易、贮存、远期交割、数字交易等全产业链数据锚定与查询。' ,
        label: [
            '种植',
            '加工',
            '检验认证',
            '仓储物流',
            '交易',
        ],
        link: '',
        logo: [
            require('@/assets/images/solution-logo-02-01.png'),
            require('@/assets/images/solution-logo-02-02.png'),
            require('@/assets/images/solution-logo-02-03.png'),
        ]
    },
    { 
        id: 3, 
        title: '大湾区学历互认',
        content: '基于BID标识的学历管理平台，企业验证求职者学历更便捷，节约求职者及企业验证时间成本；求职者个人信息需授权可见，保障了信息安全，隐私不泄露；学历信息上链后难以篡改，保障了信息权责明确。“星火·链网”骨干节点（珠海横琴）搭建的学历认证平台使得价值信息在身份标识BID之间进行流转。',
        label: [
            '政府背书认证',
            '求职者信息安全',
            '企业快速验证',
        ],
        link: '',
        logo: [
            require('@/assets/images/solution-logo-03-01.png')
        ]
    },
    { 
        id: 4, 
        title: '澳门电子医疗券',
        content: '将药房、医院、私人医生、卫健部门等医疗相关单位纳入骨干节点业务子链节点，使“医疗券”的使用全部记录在案，患者与医疗机构均有迹可循。不仅能有效杜绝“医疗券”的滥用，解决澳门医疗痛点；亦可使澳门卫生局合理分配医疗资源，让“医疗券”计划重回造福澳门居民的初衷。',
        label: [
            '居民一人一码',
            '使用痕迹上链',
            '减少资源滥用',
        ],
        link: '',
        logo: [
        ]
    },
  ]);

  const solutionActive = ref(1)

  const currentSection = ref(0);
  const sectionRefs = ref([]);
  
const route = useRoute();
const router = useRouter();

  const solutionAction = ref(0);
  
  const goToSection = (index) => {
    window.scrollTo({
      top: index * window.innerHeight,
      behavior: 'smooth'
    });
    currentSection.value = index;
    router.push(`#${sections.value[index].id}`); // 更新路由
  };
  
//   const handleWheel = (e) => {
//     e.preventDefault();
//     const delta = e.deltaY;
//     if (delta > 0 && currentSection.value < sections.value.length - 1) {
//       // 向下滚动
//       goToSection(currentSection.value + 1);
//     } else if (delta < 0 && currentSection.value > 0) {
//       // 向上滚动
//       goToSection(currentSection.value - 1);
//     }
//   };


  // 添加节流函数
  const throttle = (func, delay) => {
    let timer = null;
    return function() {
      if (!timer) {
        func.apply(this, arguments);
        timer = setTimeout(() => {
          timer = null;
        }, delay);
      }
    };
  };


  const handleWheel = throttle((e) => {
    e.preventDefault();
    const delta = e.deltaY;
    if (delta > 0 && currentSection.value < sections.value.length - 1) {
      // 向下滚动
      goToSection(currentSection.value + 1);
    } else if (delta < 0 && currentSection.value > 0) {
      // 向上滚动
      goToSection(currentSection.value - 1);
    }
  }, 200); // 设置节流时间间隔为 200 毫秒，可以根据需要调整

    const scrollToSectionById = (sectionId) => {
        const targetIndex = sections.value.findIndex((section) => section.id === sectionId);
        if (targetIndex!== -1) {
            goToSection(targetIndex);
        }
    };


    // 阻止视频暂停
    const preventPause = (event) => {
    event.target.play();
    };

    watch(
        () => route.hash,
        (newHash) => {
            const sectionId = newHash.slice(1); // 去掉 # 符号
            if (sectionId) {
                scrollToSectionById(sectionId);
            }
        },
        { immediate: true }
    );
  
  onMounted(() => {
    // 将事件监听器设置为非被动模式
    window.addEventListener('wheel', handleWheel, { passive: false });
    const initialHash = route.hash.slice(1);
    if (initialHash) {
        scrollToSectionById(initialHash);
    }
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    window.removeEventListener('wheel', handleWheel);
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 
  .section {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    position: relative;
  }
  
  .fp-right-nav {
    position: fixed;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 100;
  }
  
  .fp-right-nav ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .fp-right-nav ul li {
    width: 11px;
    height: 11px;
    margin: 12px 0;
    cursor: pointer;
  }
  
  .fp-right-nav ul li span {
    display: block;
    width: 7px;
    height: 7px;
    margin: auto;
    border-radius: 50%;
    background-color: #FFFFFF;
  }
  
  .fp-right-nav ul li.active span {
    width: 11px;
    height: 11px;
    background-color: #ea5413;
  }

  /* 定义动画 */
    
    .title_box {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .title_container {
        width: 1200px;
        margin: auto;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }
    .title_text_box {
    }
    .text_01 {
        animation: revealText 1s ease-in-out forwards;
        color: #FFFFFF;
        text-align: right;
        opacity: 0; /* 初始透明度为 0 */
    }
    .text_02 {
        animation: revealText 1s ease-in-out forwards;
        color: #FFFFFF;
        text-align: right;
        animation-delay: .2s; /* 添加延迟 2 秒 */
        opacity: 0; /* 初始透明度为 0 */
    }
    .line_01 {
        animation: revealText 1s ease-in-out forwards;
        animation-delay: .4s; /* 添加延迟 4 秒 */
        opacity: 0; /* 初始透明度为 0 */
        width: 69px;
        height: 3px;
        background-color: #FFFFFF;
    }
    .btn-toggle {
        cursor: pointer;
        color: #fff;
        display: flex;
        flex-direction: column;
        left: 50%;
        transform: translateX(-50%);
        bottom: 25px;
        position: absolute;
        z-index: 3;
        font-size: 15px;
        align-items: center;
    }
    .btn-toggle i {
        background: url(../../assets/images/btn-toggle.png) no-repeat center / 100%;
        width: 20px;
        height: 28px;
        animation: toggleMove 1.5s infinite;
        margin-bottom: 10px;
    }

    .introduction {
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        width: 1200px;
        margin: auto;
        height: calc(100% - 84px);
        margin-top: 84px;
        align-items: center;
    }
    .introduction .pic {
        width: 47.2%;
        transform-origin: left bottom;
        transition: 1s ease;
        transition-delay: 0.5s;
        position: relative;
    }
    .introduction .pic .intro-pic {
        max-width: 100%;
        object-fit: cover;
        height: auto;
        transition: all .4s ease;
    }
    #introduction {
        background: #f5f8fc;
    }
    .introduction .pic .one {
        left: 16%;
        top: -20%;
        position: absolute;
        animation: float-pic 5s ease-in-out infinite 1s;
    }
    .introduction .pic .two {
        left: 6%;
        top: 20%;
        position: absolute;
        animation: float-pic 5s ease-in-out infinite 1s;
    }
    .introduction .pic .three {
        right: 7.2%;
        top: 10%;
        position: absolute;
        animation: float-pic 5s ease-in-out infinite 1s;
    }
    .introduction .pic .four {
        left: 44.5%;
        bottom: 9%;
        position: absolute;
        animation: float-pic 5s ease-in-out infinite 1s;
    }
    .introduction .content {
        width: 50%;
        animation: com-animate 1.5s ease both .5s;
        opacity: 0;
        transform: scale(.95) translateY(40px);
        font-size: 16px;
    }
    .introduction .content .com-btn {
        position: relative;
        z-index: 1;
        border-radius: 30px;
        overflow: hidden;
        display: inline-block;
        color: #fff;
        background: #ea5413;
        font-size: 14px;
        line-height: 1;
        padding: 15px 28px;
        transition: all .4s ease;
        font-weight: normal;
        margin-top: 40px;
        cursor: pointer;
    }
    .introduction .content .com-btn:hover {
        color: #EA5413;
        background: transparent;
        box-shadow: inset 0 0 0 2px;
    }
    #solution {
        position: relative;
    }
    .solution {
        
        width: 100vw;
        height: 100%;
    }
    .solution-bg {
        position: relative;
        width: 100%;
        height: calc(100% - 84px);
        margin-top: 84px;
    }
    .solution-bg .bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        text-align: center;
        transition: all 1.5s cubic-bezier(0.23,1,0.32,1);
        background-repeat: no-repeat;
        background-size: cover;
        visibility: hidden;
        opacity: 0;
    }
    .solution-bg .bg.active {
        opacity: 1;
        visibility: visible;
    }
    .solution-container {
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin: auto;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        color: #FFFFFF;
    }
    .solution-container .solution-title {
        animation: to-up 1.5s ease both;
        font-size: 28px;
        opacity: 0;
        transform: translateY(50px);
        text-align: center;
        margin: 0 auto;
    }
    .solution-container .solution-text-01 {
        animation: to-up 1.5s ease both;
        font-size: 14px;
        opacity: 0;
        transform: translateY(50px);
        text-align: center;
        margin: 15px auto;
    }
    .solution-content {
        display: flex;
        width: 1200px;
        justify-content: space-between;
        margin: 0 auto;
        margin-top: 30px;
    }
    .solution-content .solution-list {
        width: 18.5%;
        background: rgba(255, 255, 255, 0.2);
        height: 462px;
        text-align: center;
        padding: 40px 0;
        border-radius: 4px;

        height: 400px;
        padding: 30px 0;

        animation: to-right 1.5s ease both 0.2s;
        opacity: 0;
        transform: translateX(-50px);
    }
    .solution-item {
        margin-top: 16px;
        position: relative;
        padding: 0 10px 0 54px;
        text-align: left;
    }
    .solution-item .solution-title {
        padding: 3px;
        cursor: pointer;
        color: #fff;
        display: inline-flex;
        align-items: center;
        font-size: 16px;
        padding: 5px;
        border-radius: 5px;
        transition: background 0.4s ease;
    }
    .solution-item.active:after {
        background: #ea5413;
    }
    .solution-item.active .solution-title {
        color: #ea5413;
    }
    .solution-item:after {
        content: '';
        height: calc(100% - 10px);
        transform: scale(0);
        transform-origin: center;
        transition: opacity 0.4s ease, transform 0.4s ease;
        opacity: 0;
        visibility: hidden;
        width: 4px;
        background: #fff;
        position: absolute;
        left: 0;
        top: 5px;
    }
    .solution-item:hover:after, .solution-item.active:after {
        transform: scale(1);
        opacity: 1;
        visibility: visible;
    }
    .solution-item:not(.active) .solution-title:hover {
        background: rgba(255, 255, 255, 0.1);
    }
    .solution-item-content {
        animation: to-left 1.5s ease both 0.2s;
        opacity: 0;
        transform: translateX(50px);
        width: 74.5%;
        color: #fff;
    }
    .solution-item-content .swiper-container {
        margin-left: auto;
        margin-right: auto;
        position: relative;
        overflow: hidden;
        list-style: none;
        padding: 0;
        z-index: 1;
        width: 100%;
        overflow: hidden;
    }
    .solution-item-content .swiper-container .swiper-wrapper {
        margin-left: auto;
        margin-right: auto;
        position: relative;
        overflow: hidden;
        list-style: none;
        padding: 0;
        z-index: 1;
        display: flex;

        transition: transform 0.5s ease-in-out;
    }
    .solution-item-content .swiper-container .swiper-wrapper .swiper-item {
        
    }
    .swiper-item .title {
        font-size: 24px;
        font-weight: bold;
        line-height: 1;
    }
    .swiper-item .desc {
        margin-top: 15px;
        font-size: 16px;
        line-height: 24px;
        max-width: 900px;
    }
    .swiper-item .label_list {
        margin-top: 30px;
        display: flex;
        flex-wrap: wrap;
        margin: -20px 0 0 -20px;
        margin-top: 30px;
    }
    .swiper-item .label_list .label_item {
        color: #fff;
        font-size: 14px;
        background: rgba(255, 255, 255, 0.2);
        text-align: center;
        margin: 20px 0 0 20px;
        border-radius: 4px;
        width: 122px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .swiper-item .label_list .label_item_btn {
        color: #fff;
        font-size: 14px;
        background: rgba(255, 255, 255, 0.2);
        text-align: center;
        margin: 20px 0 0 20px;
        border-radius: 4px;
        width: 122px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        
        background: #ea5413;
        border-radius: 4px;
        transition: all .4s ease;
    }
    .swiper-item .label_list .label_item_btn:hover {
        color: #EA5413;
        background: transparent;
        box-shadow: inset 0 0 0 2px;
    }
    
    .swiper-item .logo_list {
        background: rgba(255, 255, 255, 0.4);
        border-radius: 4px;
        display: flex;
        flex-wrap: wrap;
        max-width: 82.5%;
        padding: 20px 0;
        margin-top: 30px;
    }
    .swiper-item .logo_list .logo_item {
        width: 25%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .swiper-item .logo_list .logo_item img {
        max-width: 80%;
        max-height: 80%;
        width: auto;
        height: auto;
        transition: all .4s ease;
        object-fit: cover;
        vertical-align: middle;
    }

    .cooperator {
        position: relative;
        width: 100%;
        height: calc(100vh - 84px);
        margin-top: 84px;
    }
    .cooperator-bg {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #F6F8FA;
    }
    .cooperator-bg .bg1 {
        position: absolute;
        top: 0;
        left: 0;
        transform: scale(0);
        transform-origin: left top;
        transition: all 1s ease .4s;
    }
    .cooperator-bg .bg2 {
        position: absolute;
        top: 0;
        right: 0;
        transform: scale(0);
        transform-origin: right top;
        transition: all 1s ease .4s;
    }
    .cooperator-bg .bg3 {
        position: absolute;
        top: 3%;
        left: 38%;
        animation: _bg2 5s ease-in-out infinite .2s;
    }
    .cooperator-bg .bg4 {
        position: absolute;
        top: 20%;
        left: 16%;
        animation: float-pic 5s ease-in-out infinite;
    }
    .cooperator-bg .bg5 {
        position: absolute;
        bottom: 0;
        left: 9%;
        animation: _bg2 5s ease-in-out infinite;
    }
    .cooperator-bg .bg6 {
        position: absolute;
        bottom: 0;
        right: 0;
        transform: scale(0);
        transform-origin: right bottom;
        transition: all 1s ease .4s;
    }
    .cooperator-bg.animate .bg1, 
    .cooperator-bg.animate .bg2, 
    .cooperator-bg.animate .bg6 {
        transform: scale(1);
    }

    .cooperator-container {
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin: auto;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        color: #000000;
    }
    .cooperator-container .cooperator-title {
        animation: to-up 1.5s ease both;
        font-size: 28px;
        opacity: 0;
        transform: translateY(50px);
        text-align: center;
        margin: 0 auto;
    }
    .cooperator-container .cooperator-text-01 {
        animation: to-up 1.5s ease both;
        font-size: 14px;
        opacity: 0;
        transform: translateY(50px);
        text-align: center;
        margin: 15px auto;
    }
    .cooperator-content {
        display: flex;
        width: 1200px;
        margin: 0 auto;
        margin-top: 30px;
        flex-wrap: wrap;
        animation: to-up 1.5s ease both;
    }
    .cooperator-list {
        display: flex;
        width: 1200px;
        flex-wrap: wrap;
    }
    .cooperator-list .cooperator-item {
        border-radius: 5px;
        transition: all .4s ease;
        background: #fff;
        height: 98px;
        width: calc(16.66% - 12px);
        margin-left: 12px;
        margin-top: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0px 13px 17px 0px rgba(152, 172, 194, 0.14);
    }
    .cooperator-list .cooperator-item img {
        max-width: 80%;
        max-height: 80%;
        width: auto;
        height: auto;
        transition: all .4s ease;
    }
    .cooperator-list .cooperator-item:hover {
        transform: translateY(-4px);
        box-shadow: 0px 13px 17px 0px rgba(152, 172, 194, 0.33);
    }

    .video-container,.video-container video {
        height: 100%;
    }
    p {
        min-height: 20px;
    }
  </style>